/* ─── Positioner ─── */

.positioner {
  z-index: var(--z-popover);
}

/* ─── Popup ─── */

.popup {
  background: var(--md-surface-container-lowest);
  box-shadow: var(--elevation-3);
  border: 1px solid var(--md-outline-variant);
  border-radius: var(--shape-md);
  padding: var(--space-4);
  max-width: 320px;
  outline: none;
  font-family: var(--font-sans);
  transition: opacity var(--motion-duration-short3)
      var(--motion-easing-standard),
    transform var(--motion-duration-short3) var(--motion-easing-standard);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.95);
}

/* ─── Arrow ─── */

.arrow {
  width: 10px;
  height: 10px;
}

.arrow[data-side="top"] {
  bottom: -5px;
}

.arrow[data-side="bottom"] {
  top: -5px;
}

.arrow[data-side="left"] {
  right: -5px;
}

.arrow[data-side="right"] {
  left: -5px;
}

/* ─── Title ─── */

.title {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  margin: 0;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Close button ─── */

.close {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: none;
  border-radius: var(--shape-full);
  background: transparent;
  color: var(--md-on-surface-variant);
  cursor: pointer;
}

.close::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .close:hover::before {
    opacity: var(--state-hover);
  }
}

.close:focus-visible::before {
  opacity: var(--state-focus);
}

.close:active::before {
  opacity: var(--state-pressed);
}

.close svg {
  width: 1rem;
  height: 1rem;
}

/* ─── Backdrop (modal mode) ─── */

.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: rgb(var(--md-scrim) / var(--scrim-opacity));
  transition: opacity var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.backdrop[data-starting-style],
.backdrop[data-ending-style] {
  opacity: 0;
}
